import React, { useEffect, useState } from "react";
import Pagelayout from "../components/Pagelayout";
import { useLocation, useNavigate } from "react-router-dom";
import {Paper,TextField,Select, MenuItem, FormControl,InputLabel,Grid,  Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Box,Typography,Autocomplete,IconButton,Skeleton,} from "@mui/material";
import {getCurrentDate, toSystemDate,
} from "../../../../util/utilityFunctions";
import {departmentListApi,fetchMultipleAPIs,getAllBranchesAPI, getPaySlipList, listJournalCategory, postDisbursement, salaryDisbursementSingleView,saveDisbursement,updateSalaryDisbursement,
} from "../parollAPIs";
import ErrorPage from "../../../error/ErrorPage";
import { Trash2 } from "lucide-react";

const CreateSalaryDisbursement = () => {
  const location = useLocation();
  const singleViewId =
    location?.state?._id || localStorage.getItem("singleViewId") || null;
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/userdashboard/payroll/salarydisbursement");
  };

  // State
  const [payslipListData, setPayslipListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [listData, setListData] = useState(null);
  const [formData, setFormData] = useState({
    paymentMethod: null,
    accountingDate: getCurrentDate(),
    paymentType: null,
    reference: "",
    chequeOrTxnNo: "",
    transactionDate: getCurrentDate(),
    branch: null,
    department: null,
    payslipList: [],
    name: null,
    status: "NEW",
    _id: null,
  });
  const [edit, setEdit] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "",
  });
  // delete row

  const handleDeleteRow = (id) => {
    const updatedPayslipList = formData.payslipList.filter(
      (row) => row._id !== id
    );

    setFormData({
      ...formData,
      payslipList: updatedPayslipList,
    });
  };

  // Generic handler for all input changes
  const handleInputChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
    // Clear error when user starts typing
    setFormErrors((prev) => ({ ...prev, [field]: "" }));
  };

  // Special handler for date fields
  const handleDateChange = (field) => (date) => {
    setFormData((prev) => ({
      ...prev,
      [field]: date,
    }));
    setFormErrors((prev) => ({ ...prev, [field]: "" }));
  };

  // Special handler for autocomplete fields
  const handleAutocompleteChange = (field) => (event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      [field]: newValue,
    }));
    setFormErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const CHEQUERequiredField = (value, fieldName) => {
    if (!value || (typeof value === "string" && !value.trim())) {
      return `${fieldName} is required`;
    }
    return "";
  };

  // Modified handleSave and validateForm
  const validateForm = () => {
    const errors = {
      paymentMethod: CHEQUERequiredField(
        formData.paymentMethod,
        "Payment Method"
      ),
      accountingDate: CHEQUERequiredField(
        formData.accountingDate,
        "Accounting Date"
      ),
      paymentType: CHEQUERequiredField(formData.paymentType, "Payment Type"),
      reference: CHEQUERequiredField(formData.reference, "Reference"),
      chequeOrTxnNo: CHEQUERequiredField(
        formData.chequeOrTxnNo,
        formData.paymentType === "CHEQUE" ? "Cheque No" : "Transaction No"
      ),
      transactionDate: CHEQUERequiredField(
        formData.transactionDate,
        "Transaction Date"
      ),
      branch: CHEQUERequiredField(formData.branch, "Branch"),
      department: CHEQUERequiredField(formData.department, "Department"),
    };

    // Filter out empty error messages and set the errors state
    const filteredErrors = Object.fromEntries(
      Object.entries(errors).filter(([_, value]) => value !== "")
    );

    setFormErrors(filteredErrors);
    return Object.keys(filteredErrors).length === 0; // Returns true if no errors
  };

  const handleSave = () => {
    if (validateForm()) {
      setLoading(true);
      //save
      if (formData.status === "NEW") {
        saveDisbursement({
          body: formData,
          successCallback: (data) => {
            setLoading(false);
            localStorage.setItem("singleViewId", data._id);
            setEdit(!edit);

            setFormData((prev) => ({
              ...prev,
              _id: data._id,
              status: data.status,
            }));

            setSnackbar({
              open: true,
              message: "salary disbursement has been added",
              severity: "success",
            });
          },
          errorCallback: (error) => {
            console.log("Error:", error);
            setLoading(false);
            setSnackbar({
              open: true,
              message: error.message,
              severity: "error",
            });
          },
        });
        // update
      } else {
        updateSalaryDisbursement({
          body: formData,
          successCallback: (data) => {
            setLoading(false);
            setEdit(!edit);

            setSnackbar({
              open: true,
              message: "salary disbursement has been updated",
              severity: "success",
            });
          },
          errorCallback: (error) => {
            setLoading(false);
            console.log(error);
            setSnackbar({
              open: true,
              message: error.message,
              severity: "error",
            });
          },
        });
      }
    } else {
      setLoading(false);
      setSnackbar({
        open: true,
        message: "Please fill all required fields",
        severity: "error",
      });
    }
  };

  //post
  const handlePostBtn = () => {
    if (singleViewId) {
      postDisbursement({
        body: { _id: formData._id },
        successCallback: (data) => {
          setEdit(!edit);
          setFormData((prev) => ({
            ...prev,
            _id: data._id,
            status: "POSTED",
          }));

          setSnackbar({
            open: true,
            message: "salary disbursement has been post",
            severity: "success",
          });
        },
        errorCallback: (error) => {
          console.log(error);
          setSnackbar({
            open: true,
            message: error.message,
            severity: "error",
          });
        },
      });
    }
  };

  // Rest of your useEffect hooks remain the same
  useEffect(() => {
    if (formData.branch && formData.department) {
      getPaySlipList({
        branch: formData.branch._id,
        department: formData.department._id,
        successCallback: (data) => {
          setPayslipListData(data);
          if (formData.status === "NEW") {
            setFormData((prev) => ({ ...prev, payslipList: data }));
          }
        },
        errorCallback: (error) => {
          setPayslipListData([]);

          console.log("Error:", error);
        },
      });
    } else {
      // setFormData((prev) => ({ ...prev, payslipList: [] }));
    }
  }, [formData.branch, formData.department]);

  useEffect(() => {
    const apiCallsWithNames = [
      {
        name: "branch",
        apiCall: getAllBranchesAPI({
          successCallback: () => {},
          errorCallback: () => {},
        }),
      },
      {
        name: "department",
        apiCall: departmentListApi({
          successCallback: () => {},
          errorCallback: () => {},
        }),
      },
      {
        name: "journal",
        apiCall: listJournalCategory({
          successCallback: () => {},
          errorCallback: () => {},
        }),
      },
    ];

    fetchMultipleAPIs({
      apiCallsWithNames,
      setLoading,
      setErrorMsg,
      onSuccess: (res) => {
        setListData(res.data);
      },
      onError: (error) => {
        console.error("Error:", error);
        setErrorMsg(error);
        setSnackbar({
          open: true,
          message: error.message,
          severity: "error",
        });
      },
    });
  }, []);

  useEffect(() => {
    if (singleViewId) {
      setLoading(true);
      salaryDisbursementSingleView({
        id: singleViewId,
        successCallback: (data) => {
          setEdit(true);
          setLoading(false);

          setFormData({
            reference: data?.referance || "",
            paymentType: data?.paymentType,
            accountingDate: data?.accountingDate ? toSystemDate(new Date(data.accountingDate).toISOString()) : "",
            transactionDate: data?.txnDate ? toSystemDate(new Date(data.txnDate).toISOString()) : "",
            chequeOrTxnNo: data?.chequeNo || "",
            paymentMethod:
              listData?.journal?.find((r) => r._id === data?.paymentMethod) ||
              null,
            branch:
              listData?.branch?.find((r) => r._id === data?.branchId) || null,
            department:
              listData?.department?.find((r) => r._id === data?.department) ||
              null,
            status: data?.status || "NEW",
            name: data?.name,
            payslipList: data?.payslipData,
            _id: data?._id || null,
          });
        },
        errorCallback: (error) => {
          console.log("Error:", error);
          setSnackbar({
            open: true,
            message: error.message,
            severity: "error",
          });
        },
      });
    }
  }, [listData?.branch, listData?.department, singleViewId, payslipListData]);

  if (errorMsg) {
    return <ErrorPage />;
  }
  const handleIsEdit = () => {
    setEdit(!edit);
  };

  return (
    <Pagelayout
      snackbar={snackbar}
      setSnackbar={setSnackbar}
      headerLayout={2}
      pageName={"Create Salary Disbursement"}
      handleBack={handleBack}
      handleSave={handleSave}
      newData={!edit}
      actionBtn={formData.status !== "POSTED"}
      status={formData?.status}
      handleEdit={handleIsEdit}
      postBtn={formData.status === "DRAFT"}
      editBtn={formData.status === "NEW" || formData.status === "DRAFT"}
      handlePost={handlePostBtn}
      isLoading={loading}
    >
      {loading ? (
        <PayslipFormSkeleton />
      ) : (
        <>
          {/* <Paper sx={{ p: 2, mb: 2 }}> */}
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  fullWidth
                  size="small"
                  value={formData.paymentMethod}
                  onChange={handleAutocompleteChange("paymentMethod")}
                  getOptionLabel={(option) => option.journalName || ""}
                  options={listData?.journal || []}
                  isOptionEqualToValue={(option, value) => option === value}
                  disabled={
                    formData.status === "POSTED" ||
                    (formData.status === "DRAFT" && edit)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Payment Method"
                      InputLabelProps={{ shrink: true }}
                      error={!!formErrors.paymentMethod}
                      helperText={formErrors.paymentMethod}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  size="small"
                  label="Accounting Date"
                  type="date"
                  value={formData.accountingDate || ""}
                  onChange={handleInputChange("accountingDate")}
                  InputLabelProps={{ shrink: true }}
                  error={!!formErrors.accountingDate}
                  helperText={formErrors.accountingDate}
                  disabled={
                    formData.status === "POSTED" ||
                    (formData.status === "DRAFT" && edit)
                  }
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <Autocomplete
                  fullWidth
                  size="small"
                  value={formData.paymentType}
                  onChange={handleAutocompleteChange("paymentType")}
                  options={["MANUAL", "CHEQUE"]}
                  disabled={
                    formData.status === "POSTED" ||
                    (formData.status === "DRAFT" && edit)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Payment Type"
                      InputLabelProps={{ shrink: true }}
                      error={!!formErrors.paymentType}
                      helperText={formErrors.paymentType}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  size="small"
                  label="Reference"
                  value={formData.reference}
                  onChange={handleInputChange("reference")}
                  InputLabelProps={{ shrink: true }}
                  error={!!formErrors.reference}
                  helperText={formErrors.reference}
                  disabled={
                    formData.status === "POSTED" ||
                    (formData.status === "DRAFT" && edit)
                  }
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  size="small"
                  label={
                    formData.paymentType === "CHEQUE"
                      ? "Cheque No"
                      : "Transaction No"
                  }
                  value={formData.chequeOrTxnNo}
                  onChange={handleInputChange("chequeOrTxnNo")}
                  InputLabelProps={{ shrink: true }}
                  error={!!formErrors.chequeOrTxnNo}
                  helperText={formErrors.chequeOrTxnNo}
                  disabled={
                    formData.status === "POSTED" ||
                    (formData.status === "DRAFT" && edit)
                  }
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  size="small"
                  label="Transaction Date"
                  type="date"
                  value={formData.transactionDate || ""}
                  onChange={handleInputChange("transactionDate")}
                  InputLabelProps={{ shrink: true }}
                  error={!!formErrors.transactionDate}
                  helperText={formErrors.transactionDate}
                  disabled={
                    formData.status === "POSTED" ||
                    (formData.status === "DRAFT" && edit)
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  fullWidth
                  size="small"
                  value={formData.branch}
                  onChange={handleAutocompleteChange("branch")}
                  getOptionLabel={(option) => option.branchName || ""}
                  options={listData?.branch || []}
                  disabled={
                    formData.status === "POSTED" ||
                    (formData.status === "DRAFT" && edit)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Branch"
                      InputLabelProps={{ shrink: true }}
                      error={!!formErrors.branch}
                      helperText={formErrors.branch}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  fullWidth
                  size="small"
                  value={formData.department}
                  onChange={handleAutocompleteChange("department")}
                  getOptionLabel={(option) => option.departmentName || ""}
                  options={listData?.department || []}
                  disabled={
                    formData.status === "POSTED" ||
                    (formData.status === "DRAFT" && edit)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Department"
                      InputLabelProps={{ shrink: true }}
                      error={!!formErrors.department}
                      helperText={formErrors.department}
                    />
                  )}
                />
              </Grid>
            </Grid>
          {/* </Paper> */}
          {formData?.payslipList?.length > 0 && (
            <Paper sx={{ mt: 2 }}>
              <Box
                sx={{
                  height: "400px",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                }}>
                <TableContainer
                  sx={{
                    flex: 1,
                    overflow: "auto",
                    "&::-webkit-scrollbar": {
                      width: "6px",
                      height: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#888",
                      borderRadius: "3px",
                    },
                  }} >
                  <Table stickyHeader size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Employee</TableCell>
                        <TableCell align="right">Net Salary</TableCell>
                        {!edit && formData.status !== "POSTED" && (
                          <TableCell align="center">Action</TableCell>
                        )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formData?.payslipList?.map((row) => (
                        <TableRow key={row._id}>
                          <TableCell>{row?.employeeData?.empName}</TableCell>
                          <TableCell align="right">
                            {row.yearlyCtc.toFixed(2)}
                          </TableCell>
                          {!edit && formData.status !== "POSTED" && (
                            <TableCell align="center">
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => handleDeleteRow(row._id)}
                                aria-label="delete"
                              >
                                <Trash2 fontSize="small" />
                              </IconButton>
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                {/* Footer with Table structure */}
                <Table
                  sx={{
                    backgroundColor: "#f5f5f5",
                    borderTop: "1px solid rgba(224, 224, 224, 1)",
                  }} >
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <Typography variant="subtitle1" fontWeight="bold">
                          Total
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="subtitle1" fontWeight="bold">
                          {formData?.payslipList
                            ?.reduce((sum, row) => sum + row.yearlyCtc, 0)
                            .toFixed(2)}
                        </Typography>
                      </TableCell>
                      {!edit && (
                        <TableCell align="center" sx={{ px: "2.4em" }} />
                      )}
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            </Paper>
          )}
        </>
      )}
    </Pagelayout>
  );
};
export default CreateSalaryDisbursement;
const PayslipFormSkeleton = () => {
  return (
    <>
      {/* Form Skeleton */}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Grid container spacing={2}>
          {/* 8 input fields in a 4x2 grid */}
          {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
            <Grid item xs={12} md={3} key={item}>
              <Skeleton variant="rounded" height={40} />
              <Skeleton variant="text" width="60%" sx={{ mt: 0.5 }} />
            </Grid>
          ))}
        </Grid>
      </Paper>
      {/* Table Skeleton */}
      <Paper sx={{ mt: 2 }}>
        <Box
          sx={{
            height: "400px",
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }} >
          <TableContainer
            sx={{
              flex: 1,
              overflow: "auto",
            }}   >
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Skeleton variant="text" width="80px" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="text" width="80px" />
                  </TableCell>
                  <TableCell align="center">
                    <Skeleton variant="text" width="60px" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Simulate 5 rows of data */}
                {[1, 2, 3, 4, 5].map((row) => (
                  <TableRow key={row}>
                    <TableCell>
                      <Skeleton variant="text" width="120px" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width="80px" />
                    </TableCell>
                    <TableCell align="center">
                      <Skeleton variant="circular" width={24} height={24} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {/* Footer Skeleton */}
          <Table
            sx={{
              backgroundColor: "#f5f5f5",
              borderTop: "1px solid rgba(224, 224, 224, 1)",  }} >
            <TableBody>
              <TableRow>
                <TableCell>
                  <Skeleton variant="text" width="60px" />
                </TableCell>
                <TableCell align="right">
                  <Skeleton variant="text" width="80px" />
                </TableCell>
                <TableCell align="center" sx={{ px: "2.4em" }}>
                  <Skeleton variant="text" width="0px" />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Paper>
    </>
  );
};
